import { List, Create, Show, Edit } from "../Components/index.js";

export default [
    {
        path: "/letter/folder",
        component: List,
        name: "letter.folder",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/letter/folder/create",
        component: Create,
        name: "letter.folder.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/letter/folder/:id/edit",
        component: Edit,
        name: "letter.folder.edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/letter/folder/:id/view",
        component: Show,
        name: "letter.folder.view",
        meta: {
            requiresAuth: true,
        },
    },
];
